import { useState, useEffect, Dispatch } from "react";
import { StopEventPropagation } from "../../../helper/ui/methods";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import { FolderCreateInterface } from "../../../middleware/interfaces/folder/folder-create-interface";
import { FormatDateBE } from "../../../helper/general/methods";
import { FolderInterface } from "../../../middleware/interfaces/folder/folder-interface";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";

interface folderDialogProps {
  reveal: string;
  user: UserInterface;
  setFolderDialogReveal: Dispatch<React.SetStateAction<string>>;
  selectedFolder: FolderInterface | undefined | null;
  dispatch: Dispatch<any>;
}

const FolderDialog: React.FC<folderDialogProps> = ({
  reveal,
  user,
  setFolderDialogReveal,
  selectedFolder,
  dispatch,
}) => {
  const [folderName, setFolderName] = useState<string>("");

  const HandleCancelClick = () => {
    setFolderDialogReveal("");
  };

  const FolderCreate = () => {
    const folder: FolderCreateInterface = {
      email: user.email,
      projectID: user.openProject?.projectID!,
      projectName: user.openProject?.projectName!,
      projectUserRole: user.openProject?.projectUserRole!,
      folderParentID: user.openFolder?.folderID,
      folderName: folderName,
      folderCreationDate: FormatDateBE(new Date()),
      type: "FolderCreateInterface",
    };
    dispatch({ type: "CREATE_FOLDER", payload: folder });
    setFolderDialogReveal("");
  };

  const FolderEdit = () => {
    setFolderDialogReveal("");
    const decision: UserDecisionInterface = {
      title: "Rename folder?",
      message: "The folder keeps its contents; only its name changes.",
      confirmLabel: "Save",
      decisionOptions: ["EDIT_FOLDER", "NO_ACTION"],
      result: "",
      data: {
        email: user.email,
        projectUserRole: user.openProject?.projectUserRole!,
        projectID: selectedFolder?.projectID!,
        folderName: folderName,
        folderID: selectedFolder?.folderID,
        type: "FolderEditInterface",
      },
      type: "UserDecisionInterface",
    };
    dispatch({ type: "DECISION", decision: decision });
  };

  useEffect(() => {
    if (reveal === "") {
      setFolderName("");
    } else if (reveal === "EDIT") {
      setFolderName(selectedFolder?.folderName!);
    }
  }, [reveal]);

  if (!reveal) {
    return null;
  }
  const isCreate = reveal === "CREATE";

  return (
    <div className="dialogCover" onClick={StopEventPropagation}>
      <div className="dialog">
        <div className="dialogHeader">
          <div className="dialogHeading">
            <h2 className="dialogTitle">
              {isCreate ? "New folder" : "Rename folder"}
            </h2>
          </div>
          <span className="dialogClose" onClick={HandleCancelClick}>
            ×
          </span>
        </div>
        <div className="dialogBody">
          <div className="dialogValueWrapper">
            <span className="dialogInputLabel">Name</span>
            <input
              type="text"
              name="folderName"
              placeholder="Folder name"
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
            />
          </div>
        </div>
        <div className="dialogButtonWrapper">
          <input
            type="button"
            name="cancel"
            value="Cancel"
            onClick={HandleCancelClick}
          />
          <input
            className="dialogPrimaryButton"
            type="button"
            name={isCreate ? "create" : "edit"}
            value={isCreate ? "Create" : "Save"}
            onClick={isCreate ? FolderCreate : FolderEdit}
          />
        </div>
      </div>
    </div>
  );
};

export default FolderDialog;
